var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_103_376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6082 9.84578C12.6892 9.84578 11.7869 9.70215 10.9318 9.41977C10.5128 9.27695 9.99772 9.40797 9.742 9.67043L8.05422 10.9436C6.09689 9.89953 4.89121 8.69508 3.86065 6.75379L5.09725 5.11113C5.41853 4.79051 5.53376 4.32215 5.3957 3.8827C5.11191 3.02371 4.96775 2.12242 4.96775 1.20367C4.96779 0.539961 4.42745 0 3.76332 0H1.00672C0.342582 0 -0.197754 0.539961 -0.197754 1.20363C-0.197754 8.81105 5.99553 15 13.6082 15C14.2724 15 14.8127 14.46 14.8127 13.7964V11.0494C14.8127 10.3857 14.2723 9.84578 13.6082 9.84578Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_103_376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.51dfbdb6ff7bee7368f923de10d6d06f.svg";
export { ForwardRef as ReactComponent };